import type { ISubscriptionActive } from '../types/subscription';

import { create } from 'zustand';

export interface ISubscriptionStoreState {
  subscriptionActive?: ISubscriptionActive;
  isFetchedSubscriptionActive: boolean;
}

export interface ISubscriptionStoreActions {
  setSubscriptionActive: (value?: ISubscriptionActive) => void;
  setIsFetchedSubscriptionActive: (value: boolean) => void;
}

export const useSubscriptionStore = create<ISubscriptionStoreState & ISubscriptionStoreActions>()(
  (set) => ({
    subscriptionActive: undefined,
    isFetchedSubscriptionActive: false,

    setSubscriptionActive: (val?: ISubscriptionActive) => {
      set(() => ({ subscriptionActive: val }));
    },
    setIsFetchedSubscriptionActive: (value: boolean) => {
      set(() => ({ isFetchedSubscriptionActive: value }));
    },
  }),
);
